import React from 'react';
import { Box, Alert, Typography } from '@mui/material';
import { getSpacing } from '@/styles/theme';

interface ErrorDisplayProps {
  error: string;
  severity?: 'error' | 'warning' | 'info' | 'success';
  description?: string | React.ReactNode;
  padding?: string | number;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  severity = 'error',
  description,
  padding = getSpacing.xl,
}) => {
  return (
    <Box sx={{ p: padding }}>
      <Alert severity={severity} sx={{ mb: 2 }}>
        {error}
      </Alert>
      {description && (
        <Typography variant='body1' color='text.secondary'>
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default ErrorDisplay;
